import * as React from "react";
import { Link } from "react-router-dom";
import cx from "classnames";

import { IRoutedTab } from "./routed";
import ThresholdSticky from "common/components/thresholdSticky";

const styles = require("./vingleTab.scss");

interface IProps {
  tabs: IRoutedTab[];
  selectedTab: IRoutedTab;
  vingleTabType: Vingle.VingleTabType;
  wrapperClassName?: string;
  accessibilityLevel?: number;
  tabBarClassName?: string;

  enableStickyNavBar?: boolean;
  stickyThreshold?: number;
  stickedTopOffset?: number | string;
  stickyChildrenWrapperClassName?: string;

  onTabClick: (clickedTab: Vingle.ITab) => void;
}

class TabRoutePage extends React.PureComponent<IProps> {
  public render() {
    const {
      selectedTab,
      tabs,
      vingleTabType,
      accessibilityLevel,
      wrapperClassName,
      tabBarClassName,
      ...rest
    } = this.props;

    return (
      <div className={wrapperClassName}>
        {this.renderAccessibilityHeading()}
        {this.renderNavBar()}
        <div className={styles.container}>
          <selectedTab.page {...rest} />
        </div>
      </div>
    );
  }

  private readonly renderAccessibilityHeading = () => {
    const { accessibilityLevel, selectedTab } = this.props;
    if (!accessibilityLevel) {
      return null;
    }
    return React.createElement(
      `h${accessibilityLevel}`,
      {
        className: "accessibility",
      },
      selectedTab.title,
    );
  };

  private readonly renderNavBar = () => {
    const {
      selectedTab,
      tabs,
      vingleTabType,
      tabBarClassName,
      enableStickyNavBar,
      stickyThreshold,
      stickedTopOffset,
      stickyChildrenWrapperClassName,
    } = this.props;
    const tabWrapperClass =
      vingleTabType === "main" ? styles.mainTabWrapper : styles.subTabWrapper;

    const tabMenu = tabs.map(tab => {
      return (
        <Link
          key={`vingleTab-${tab.key}`}
          to={(Array.isArray(tab.url) ? tab.url[0] : tab.url).toLocation({
            query: tab.qs,
          })}
          className={cx(styles.tab, {
            [styles.selected]: tab.key === selectedTab.key,
          })}
          onClick={this.handleTabClick}
          data-tab={tab.key}
        >
          <span className={styles.textBox}>{tab.title}</span>
          <div className={styles.underline} />
        </Link>
      );
    });

    if (enableStickyNavBar) {
      return (
        <ThresholdSticky
          stickyThreshold={stickyThreshold || 0}
          stickedTopOffset={stickedTopOffset}
          childrenWrapperClassName={stickyChildrenWrapperClassName}
        >
          <nav className={cx(tabWrapperClass, tabBarClassName)}>{tabMenu}</nav>
        </ThresholdSticky>
      );
    }

    return (
      <nav className={cx(tabWrapperClass, tabBarClassName)}>{tabMenu}</nav>
    );
  };

  private readonly handleTabClick: React.MouseEventHandler<
    HTMLAnchorElement
  > = e => {
    const tabKey = e.currentTarget.getAttribute("data-tab");
    const clickedTab = this.props.tabs.find(tab => {
      return tab.key === tabKey;
    });
    if (clickedTab) {
      this.props.onTabClick(clickedTab);
    }
  };
}

export default TabRoutePage;
